export enum BeachVolleyballEventDetailId {
  PossibleGoldenSet = 61,
}
